import { render, staticRenderFns } from "./BlockingAnAccessSession.vue?vue&type=template&id=85dfb372&scoped=true"
import script from "./BlockingAnAccessSession.vue?vue&type=script&lang=js"
export * from "./BlockingAnAccessSession.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85dfb372",
  null
  
)

export default component.exports